import React from "react";
import Select from 'react-select'
import {convertToOptions} from "../../../utils/arrayObjectHelper";

const componentClass = 'fieldType__dropDown';

const DropSelect = ({ onChange, options, shouldConvertOptions, value, ...rest }) => {

  const optionsToUse = shouldConvertOptions ? convertToOptions(options) : options;

  return <Select
      className={componentClass}
      classNames={{
        control: () => "dropSelect-control"
      }}
      options={optionsToUse}
      onChange={v => onChange && onChange(v?.value || v?.key)}
      value={ optionsToUse.find(o => (o?.value || o?.key || '').toString() === (value || '').toString()) }
      {...rest}
  />
};

export default DropSelect;
